export const loadExternalFiles = (): void => {
    const head = document.getElementsByTagName('head')[0];

    const cssUrls = [
        'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.6.0/css/bootstrap.min.css',
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css',
        'https://cdnjs.cloudflare.com/ajax/libs/startbootstrap-sb-admin-2/4.1.4/css/sb-admin-2.min.css'
    ];

    const jsUrls: string[] = [];

    cssUrls.forEach((url) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        head.appendChild(link);
    });

    jsUrls.forEach((url) => {
        const script = document.createElement('script');
        script.src = url;
        head.appendChild(script);
    });
};
